let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d4fpR")).then(() => parcelRequire('7kAwG'));